import { TOrdersResponse } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';

const ENTITY = 'billing';

export const getMemberOrdersQueryKey = (page: number, perPage: number) => [ENTITY, 'orders', page, perPage];

export const useGetMemberOrdersQuery = (params: { page?: number; perPage?: number; enabled?: boolean }) => {
  const { page = 1, perPage = 15, enabled = true } = params;

  return useQuery<TOrdersResponse>({
    queryKey: getMemberOrdersQueryKey(page, perPage),
    queryFn: async () => {
      const req = await axios.get(`${ENTITY}/orders`, { params: { page, perPage } });
      return req.data;
    },
    enabled,
  });
};
